import adminUserSlice from "./adminUserSlice"
import MemberSlice from "./MCMemberSlice"

const rootReducer = {
  adminUserSlice,
  MemberSlice
};

export default rootReducer;
